var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-chip',{staticClass:"bold f-16",attrs:{"color":_vm.color,"fill":"","icon":_vm.icon}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }